<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Corretora de Seguros';
</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container" style="min-height: 400px;">

	<span class="float-sm-left mr-40 mb-40" style="width: 400px; text-align: center;">
		<div>
			<picture class="image-gallery float-sm-left" style="display: flex;">
				<img class="img-fluid" src="assets/images/zimmercorretora.jpg" alt="Seguros">
			</picture>
		</div>
	</span>
	<br />
	<p>O mercado de seguros necessita de profissionais capazes e que atendem com agilidade, pois cada intempérie resulta em muita dor de cabeça para os segurados. A Zimmer Corretora de Seguros foi criada com a intenção de agilizar a intermediação entre a seguradora e segurado, atuar como um pilar que sustenta e da tranqüilidade para os clientes.</p>
	<p>Agilidade, presteza e confiança são as palavras-chave na Zimmer Corretora de Seguros. Os profissionais que i trabalham estão prontos diariamente para resolver os seus problemas com a maior agilidade possível, e com toda a qualidade de um atendimento jovem, personalizado e descomplicado.</p>
	<p>Com foco no seguro Condominial e Residencial, nossos funcionários estão a cada dia se aprimorando mais nos nossos produtos-chave, vivenciando diariamente as alterações de produtos e realizando treinamentos nas seguradoras líderes do mercado.</p>
	<p>Está pensando em resolver seus problemas de seguro? Envie-nos um e-mail para que possamos entrar em contato e sanar qualquer tipo de dúvida.</p>
	<p class="color-accent"><i class="fas fa-envelope"></i> <a href="mailto:contato@zimmerseguros.com.br" target="_blank">contato@zimmerseguros.com.br</a> | <i class="fas fa-phone-square-alt"></i> <span style="font-weight: bold;">+55 51 3336.9643</span></p>
	<p>Acesse nosso facebook para mais informações: <span class="color-accent"><i class="fab fa-facebook-square"></i> <a href="https://www.facebook.com/zimmerseguros/" target="_blank">https://www.facebook.com/zimmerseguros/</a></span></p>
	<p><i class="fas fa-download color-accent"></i> Faça download da ficha de cadastro para pessoa física:</p>
	<div class="mb-10">
		<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/files/portoseguro.pdf">
			<b>Ficha para Cadastro</b>
		</a>
	</div>
	<hr>
	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/contato" use:link replace title="Entre em Contato" class="btn btn-primary">Entre me contato <i class="far fa-arrow-right"></i></a>
	</div>
	<br />

</div>